"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Mile = exports.Inch = exports.Yard = exports.Foot = exports.Millimeter = exports.CentiMeter = exports.Decimeter = exports.Kilometer = void 0;
var uom_1 = require("uom");
exports.Kilometer = uom_1.UnitFormat.createUnitFormat("km", 2);
exports.Decimeter = uom_1.UnitFormat.createUnitFormat("dm", 0);
exports.CentiMeter = uom_1.UnitFormat.createUnitFormat("cm", 2);
exports.Millimeter = uom_1.UnitFormat.createUnitFormat("mm", 2);
exports.Foot = uom_1.UnitFormat.createUnitFormat("ft", 2);
exports.Yard = uom_1.UnitFormat.createUnitFormat("yd", 2);
exports.Inch = uom_1.UnitFormat.createUnitFormat("in", 2);
exports.Mile = uom_1.UnitFormat.createUnitFormat("mi", 0);
//# sourceMappingURL=length-format.js.map